import { styled } from '@mui/material';

import { StyledBodyLarge, StyledHeadlineLarge, ellipsisTextCss } from 'shared/styles';

export const StyledText = styled(StyledBodyLarge)(ellipsisTextCss);
export const StyledTextLarge = styled(StyledHeadlineLarge)(ellipsisTextCss);
